<template>
    <div>
        <div class="row">
            <div class="col">
                <h2 v-html="task.question" />
            </div>
        </div>
        <div class="row">
            <div class="col-6 position-relative" style="cursor: pointer;">
                <img
                    :src="task.taskable.first_image"
                    width="500px"
                    class="mx-auto"
                    alt=""
                    @click="handleClick"
                >
                <button
                    class="position-absolute"
                    v-for="(point, index) in task.taskable.points"
                    :key="`point-index-${index}`"
                    :style="`left: ${point.x}px; top:${point.y-10}px; padding: 10px; cursor: pointer; opacity: 0;`"
                    @click.prevent="handleClick($event, point)"
                />
                <span
                    v-for="(point, index) in form.points"
                    :key="`point-selected-${index}`"
                    :ref="`point`"
                    :style="`left: ${(point.x)}px; top:${point.y-10}px; padding: 8px; cursor: pointer;`"
                    :class="{'bg-success': point.status === true, 'bg-danger': point.status === false}"
                    class="position-absolute rounded-circle d-inline-flex"
                >
                    <svg
                        style="color: white;"
                        width="10px" height="10px"
                        v-if="point.status === false"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <svg
                        style="color: white;"
                        width="10px" height="10px"
                        v-if="point.status === true"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </span>
            </div>
            <div class="col-6">
                <img :src="task.taskable.second_image" width="500px" class="mx-auto" alt="">
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12 text-right">
                <span class="badge badge-pill badge-success p-3">
                    Hátralévő kattintások száma: {{ task.taskable.limit_click - click_count }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import {filter} from "lodash";

export default {
    props: {
        task: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
               this.$emit('input', this.form);
            },
        },
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                points: [],
            },
            click_count: 0,
        }
    },
    methods: {
        handleClick(event, point) {
            const clickedCount = this.click_count + 1;

            if (this.task.taskable.limit_click < clickedCount) {
                return false;
            }

            if (point !== undefined) {
                const foundPoint = filter(this.form.points, (item) => {
                    return item.x === point.x && item.y === point.y;
                });

                if (0 < foundPoint.length) {
                    return false;
                }

                this.form.points.push({
                    x: point.x,
                    y: point.y,
                    status: true,
                });
            } else {
                let index = this.form.points.push({
                    x: event.offsetX,
                    y: event.offsetY - 15,
                    status: false,
                });

                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs[`point`][index - 1].classList.remove('d-inline-flex');
                        this.$refs[`point`][index - 1].style.display = 'none';
                    }, 5000);
                })
            }

            this.click_count = clickedCount;
        }
    },
    mounted() {
        this.$emit('input', this.form);
    }
}
</script>
